import { LocationText, PositionType } from './PositionAndNavigation.styles';
import { Grid, Typography } from '../../../base';
import { IJobApplicationJob } from '../../../common';

interface Props {
    jobData: IJobApplicationJob;
}
const PositionAndNavigation = (props: Props) => {
    const { jobData } = props;
    return (
        <Grid container columnSpacing={2} alignItems="center">
            <Grid item xs>
                <Grid container direction="column">
                    <Grid item>
                        <Typography variant="h5" component="h1">
                            {jobData.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            {jobData.location && (
                                <Grid item>
                                    <LocationText variant="subtitle1">
                                        {jobData.location}
                                    </LocationText>
                                </Grid>
                            )}
                            <Grid item>
                                <PositionType variant="subtitle1">
                                    {jobData.JobType}
                                </PositionType>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PositionAndNavigation;
